import { Icon } from '@chakra-ui/react'
import { FiFilter, FiSearch, FiX, FiCrosshair, FiPlus, FiMinus } from 'react-icons/fi'

export const IconFiSettings = () => (
    <Icon as={FiFilter} boxSize={6} color="bluscheme" />
)

export const IconFiSearch = () => (
    <Icon as={FiSearch} boxSize={4} color="bluscheme" />
)

export const IconFiX = () => (
    <Icon as={FiX} boxSize={4} color="bluscheme"  />
)

export const IconFiCrosshair = () => (
    <Icon as={FiCrosshair} boxSize={4} color="bluscheme" />
)

export const IconFiPlus = () => (
    <Icon as={FiPlus} boxSize={4} color="bluscheme" />
)

export const IconFiMinus = () => (
    <Icon as={FiMinus} boxSize={4} color="bluscheme" />
)
